import type { ExtractedMessages } from '@Infra/FetchLib/ApiError/extractMessages';

export type DocumentImportFailedAction = {
	type: 'DOCUMENT_IMPORT_FAILED';
	payload: ExtractedMessages;
};

export default (payload: ExtractedMessages): DocumentImportFailedAction => ({
	type: 'DOCUMENT_IMPORT_FAILED',
	payload,
});
